import React from "react";
import { MdMenu } from "react-icons/md";
import Table from "../../common/Table";
import colors from "../../config/colors";
import config from "../../config/config";
import moment from "moment";
import addPrecision from "../../common/addPrecision";

const size = config.iconSize;
const paymentHeader = [
  { title: "Date", name: "date" },
  { title: "Amount", name: "amount" },
  { title: "Cheque Number", name: "chequeNumber" },
];
export default function PaymentsLogModel() {
  const Body = ({ payments = [] }) => {
    console.log(payments);
    return (
      <div>
        <Table
          normalTable
          tableClass="no-borders"
          header={paymentHeader}
          sortable
          data={payments.map((i) => {
            return {
              ...i,
              date: moment(i.date).format("DD/MM/YYYY"),
              amount: `$ ${addPrecision(i.amount)}`,
            };
          })}
        />
      </div>
    );
  };
  const Header = ({ invoiceId }) => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <MdMenu size={size} color={colors.silver} style={{ marginRight: 5 }} />
        <b>Payments Log - {invoiceId} </b>
      </span>
    );
  };

  return { Header, Body };
}
